var Mustache, SupportCurrentOrderModel, SupportMarketRateImagePresenterPresentation, SupportPresenterFactoryPresentation, SupportUtilsHelper;

SupportMarketRateImagePresenterPresentation = require('../presenters/market_rate_image_presenter');

SupportPresenterFactoryPresentation = require('../presenters/presenter_factory');

Mustache = require('../../../../core/frontend/vendor_modules/mustache-0.7.2');

SupportUtilsHelper = require('../helpers/utils');

SupportCurrentOrderModel = (function() {
  function SupportCurrentOrderModel() {
    var ref;
    this.currentOrder = Groupon.Support.currentOrder;
    this.groupons = (ref = this.currentOrder) != null ? ref.groupons : void 0;
    this.voucher = _.first(this.groupons || []);
  }

  SupportCurrentOrderModel.prototype.getDealFinePrint = function() {
    var ref;
    return this.currentOrder.finePrintText || ((ref = this.currentOrder.deal) != null ? ref.finePrint : void 0) || "";
  };

  SupportCurrentOrderModel.prototype.getV1ImageUrl = function() {
    var ref, ref1, ref2;
    return ((ref = this.currentOrder.deal) != null ? ref.sidebarImageUrl : void 0) || ((ref1 = this.currentOrder.deal) != null ? ref1.mediumImageUrl : void 0) || ((ref2 = this.currentOrder.deal) != null ? ref2.smallImageUrl : void 0);
  };

  SupportCurrentOrderModel.prototype.toDealHash = function() {
    var dealHash;
    dealHash = (function() {
      switch (this.currentOrder.DEAL_TYPE) {
        case 'GETAWAYS_TONIGHT':
        case 'GETAWAYS_MARKET_RATE':
          return this.getawaysMarketRateDealHash();
        case 'GETAWAYS_BOOKING':
          if (isIntl()) {
            return this.getawaysBookingDealHash();
          } else {
            return this.v1DealHash();
          }
          break;
        default:
          return this.v1DealHash();
      }
    }).call(this);
    return dealHash;
  };

  SupportCurrentOrderModel.prototype.v1DealHash = function() {
    var dealHash, ref, ref1, ref2;
    return dealHash = {
      dealId: (ref = this.currentOrder.deal) != null ? ref.id : void 0,
      merchant: (ref1 = this.currentOrder.merchant) != null ? ref1.name : void 0,
      title: (ref2 = this.currentOrder.deal) != null ? ref2.title : void 0,
      v1Image: this.getV1ImageUrl(),
      finePrint: this.getDealFinePrint()
    };
  };

  SupportCurrentOrderModel.prototype.getawaysBookingDealHash = function() {
    var dealHash, ref, ref1, ref2, reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(this.currentOrder);
    return dealHash = {
      merchant: (reservationSource != null ? reservationSource.hotelName : void 0) || ((ref = this.currentOrder.merchant) != null ? ref.name : void 0),
      title: (reservationSource != null ? reservationSource.roomNameHtml : void 0) || ((ref1 = this.currentOrder.deal) != null ? ref1.title : void 0),
      v1Image: this.getV1ImageUrl(),
      dealId: (ref2 = this.currentOrder.deal) != null ? ref2.id : void 0,
      finePrint: this.getDealFinePrint()
    };
  };

  SupportCurrentOrderModel.prototype.getawaysMarketRateDealHash = function() {
    var dealHash, reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(this.currentOrder);
    dealHash = {
      merchant: reservationSource != null ? reservationSource.hotelName : void 0,
      title: reservationSource != null ? reservationSource.roomNameHtml : void 0,
      finePrint: this.getDealFinePrint()
    };
    if (this.currentOrder.DEAL_TYPE === 'GETAWAYS_MARKET_RATE') {
      reservationSource = SupportUtilsHelper.getReservationSource(this.currentOrder);
      dealHash.imageUrl = this.currentOrder.imageUrl || (new SupportMarketRateImagePresenterPresentation).present(reservationSource != null ? reservationSource.images : void 0);
    } else {
      dealHash.imageUrl = this.currentOrder.imageUrl;
    }
    return dealHash;
  };

  SupportCurrentOrderModel.prototype.getOrderQuantity = function() {
    var quantity;
    quantity = this.currentOrder.quantity;
    if (quantity == null) {
      quantity = SupportUtilsHelper.findGrouponQuantity(this.groupons);
    }
    return quantity;
  };

  SupportCurrentOrderModel.prototype.buildOrderSummaryParams = function() {
    var orderSummaryParams, statusNotesHash;
    statusNotesHash = this.getDealStatusAndNotes();
    orderSummaryParams = {
      qty: this.getOrderQuantity(),
      shouldShowDeliveryMsg: this.currentOrder.shouldShowDeliveryMsg,
      purchasedAt: this.getpurchasedAt(),
      maxDeliveryDays: window.maxDeliveryDays[window.country.name],
      expectedDeliveryDate: this.currentOrder.expectedDeliveryDate,
      status: Mustache.to_html(statusNotesHash.status, this.statusParams(statusNotesHash.status)),
      notes: (statusNotesHash.notes != null) && statusNotesHash.notes.length !== 0 ? Mustache.to_html(statusNotesHash.notes, this.notesParams(statusNotesHash.notes)) : void 0,
      deliveryRange: this.getEstimatedDeliveryRange(),
      expressShippingTag: this.getExpressShippingTag(),
      deliveryMessage: this.getDeliveryMessage(),
      giftInfo: this.getGiftParams()
    };
    _.extend(orderSummaryParams, window.getOrderInfoForBH(this.currentOrder));
    switch (this.currentOrder.DEAL_TYPE) {
      case 'GETAWAYS_TONIGHT':
      case 'GETAWAYS_MARKET_RATE':
      case 'GETAWAYS_BOOKING':
        _.extend(orderSummaryParams, this.getReseravationParams());
    }
    return orderSummaryParams;
  };

  SupportCurrentOrderModel.prototype.getpurchasedAt = function() {
    return this.currentOrder.purchasedAtshortDatetimeStr;
  };

  SupportCurrentOrderModel.prototype.getEstimatedDeliveryRange = function() {
    var deliveryRange, ref, ref1, ref2, shipmentDetails;
    if (this.canShowEstimatedDelivery()) {
      if (this.currentOrder.shipmentDetails) {
        shipmentDetails = this.currentOrder.shipmentDetails;
        if (shipmentDetails.deliveredDate || shipmentDetails.outFordeliveryDate || shipmentDetails.shippedDate) {
          return null;
        }
        if (this.getExpressShippingTag() != null) {
          return (ref = this.voucher) != null ? ref.expressDeliveryDate : void 0;
        } else {
          deliveryRange = shipmentDetails.shippingSoonRange || shipmentDetails.shippingSoonRangePlusTwoDays || shipmentDetails.estimatedDeliveryDescription;
          if (deliveryRange) {
            return deliveryRange;
          }
        }
      }
      if (this.getExpressShippingTag()) {
        return (ref1 = this.voucher) != null ? ref1.expressDeliveryDate : void 0;
      }
      return (ref2 = this.currentOrder.deal) != null ? ref2.deliveryRange : void 0;
    } else {
      return null;
    }
  };

  SupportCurrentOrderModel.prototype.getExpressShippingTag = function() {
    var ref;
    if (((ref = this.voucher) != null ? ref.expressDeliveryDate : void 0) != null) {
      return ' (' + I18n.translate('js.modules.support.express_shipping') + ')';
    } else {
      return null;
    }
  };

  SupportCurrentOrderModel.prototype.canShowEstimatedDelivery = function() {
    var ref;
    return (ref = this.currentOrder.STATE) !== 'FAILED' && ref !== 'REFUNDED';
  };

  SupportCurrentOrderModel.prototype.getReseravationParams = function() {
    var reservationInformation, reservationSource;
    reservationInformation = {};
    reservationSource = SupportUtilsHelper.getReservationSource(this.currentOrder);
    if (reservationSource != null ? reservationSource.formattedCheckInDate : void 0) {
      reservationInformation.checkInDate = reservationSource != null ? reservationSource.formattedCheckInDate : void 0;
    }
    if (reservationSource != null ? reservationSource.formattedCheckOutDate : void 0) {
      reservationInformation.checkOutDate = reservationSource != null ? reservationSource.formattedCheckOutDate : void 0;
    }
    return reservationInformation;
  };

  SupportCurrentOrderModel.prototype.notesParams = function(notes) {
    var notesParams;
    notesParams = {};
    if (notes != null ? notes.match("editable_deadline") : void 0) {
      notesParams.editable_deadline = this.currentOrder.editableUntillongDateTimeStr;
    }
    if (notes != null ? notes.match("expired_date") : void 0) {
      notesParams.expiration_date = this.voucher.expiresAtFormattedStr;
    }
    if (notes != null ? notes.match("merchant_name") : void 0) {
      notesParams.merchant_name = this.currentOrder.merchant.name;
    }
    if (notes != null ? notes.match("isEditableUntil") : void 0) {
      notesParams.isEditableUntil = this.currentOrder.isEditableUntil;
    }
    if (notes != null ? notes.match("number_of_business_days_ago") : void 0) {
      notesParams.number_of_business_days_ago = this.currentOrder.businessDaysAfterPurchase;
    }
    return this.setShippingNotesParams(notes, notesParams);
  };

  SupportCurrentOrderModel.prototype.setShippingNotesParams = function(notes, notesParams) {
    var ref, shipmentDetails;
    shipmentDetails = this.currentOrder.shipmentDetails;
    if (shipmentDetails) {
      if (notes != null ? notes.match("shipped_date") : void 0) {
        notesParams.shipped_date = shipmentDetails.shippedDate;
      }
      if (notes != null ? notes.match("out_for_delivery_date") : void 0) {
        notesParams.out_for_delivery_date = shipmentDetails.outFordeliveryDate;
      }
      if (notes != null ? notes.match("delivered_date") : void 0) {
        notesParams.delivered_date = shipmentDetails.deliveredDate;
      }
      if (notes != null ? notes.match("tracking_number") : void 0) {
        notesParams.tracking_number = shipmentDetails.trackingNumber;
      }
      if (notes != null ? notes.match("carrier_name") : void 0) {
        notesParams.carrier_name = (ref = shipmentDetails.carrierName) != null ? ref.toUpperCase() : void 0;
      }
      this.setShippingSoonMsg(notes, notesParams);
    }
    return notesParams;
  };

  SupportCurrentOrderModel.prototype.setShippingSoonMsg = function(notes, notesParams) {
    var ref, ref1, shipmentDetails;
    notesParams.shipping_soon_msg = ((ref = this.currentOrder.deal) != null ? ref.deliveryRange : void 0) || "";
    notesParams.shipping_soon_msg_plus_two_business_days = ((ref1 = this.currentOrder.deal) != null ? ref1.deliveryRange : void 0) | "";
    shipmentDetails = this.currentOrder.shipmentDetails;
    if (shipmentDetails) {
      if (notes != null ? notes.match("shipping_soon_msg") : void 0) {
        if (shipmentDetails.shippingSoonRange != null) {
          notesParams.shipping_soon_msg = "Your order has been prepared for shipment and will be picked up by the carrier by " + shipmentDetails.shippingSoonRange + ".";
        } else if (shipmentDetails.estimatedDeliveryDescription != null) {
          notesParams.shipping_soon_msg = shipmentDetails.estimatedDeliveryDescription;
        }
      }
      if (notes != null ? notes.match("shipping_soon_msg_plus_two_business_days") : void 0) {
        if (shipmentDetails.shippingSoonRangePlusTwoDays != null) {
          return notesParams.shipping_soon_msg_plus_two_business_days = "Your order has been prepared for shipment and will be picked up by the carrier by " + shipmentDetails.shippingSoonRangePlusTwoDays + ".";
        } else if (shipmentDetails.estimatedDeliveryDescription != null) {
          return notesParams.shipping_soon_msg_plus_two_business_days = shipmentDetails.estimatedDeliveryDescription;
        }
      }
    }
  };

  SupportCurrentOrderModel.prototype.statusParams = function(status) {
    var statusParams;
    statusParams = {};
    if (status != null ? status.match("redeemed_date") : void 0) {
      statusParams.redeemed_date = this.voucher.merchantRedeemedAtshortDatetimeStr || this.voucher.customerRedeemedAtshortDatetimeStr;
    }
    if (status != null ? status.match("expiration_date") : void 0) {
      statusParams.expiration_date = this.voucher.expiresAtFormattedStr;
    }
    if (status != null ? status.match("editable_deadline") : void 0) {
      statusParams.editable_deadline = this.currentOrder.editableUntilshortDateTimeStr;
    }
    return statusParams;
  };

  SupportCurrentOrderModel.prototype.getDealStatusAndNotes = function() {
    var displayNotes, displayStatus, presenter;
    displayStatus = Groupon.Support.ContentModel.displayStatus;
    displayNotes = Groupon.Support.ContentModel.displayNotes;
    if (checkIfIsUSByCountry(country.name)) {
      presenter = SupportPresenterFactoryPresentation.prototype.makePresenter(this.currentOrder);
      return {
        status: presenter.getStatus(),
        notes: presenter.getNotes()
      };
    } else if (displayStatus || displayNotes) {
      return {
        status: displayStatus,
        notes: displayNotes
      };
    } else {
      return {
        status: Groupon.Support.currentOrder.STATE
      };
    }
  };

  SupportCurrentOrderModel.prototype.getGiftParams = function(order, I18n) {
    var hash;
    if (this.currentOrder.isGift && this.currentOrder.giftInfo) {
      hash = {
        isSentGift: this.currentOrder.giftInfo.isSentGift,
        isReceivedGift: this.currentOrder.giftInfo.isReceivedGift,
        giftRecipientName: this.currentOrder.giftInfo.giftRecipientName,
        giftFromName: this.currentOrder.giftInfo.giftFromName,
        giftRecipientEmail: this.currentOrder.giftInfo.giftRecipientEmail,
        isGiftClaimed: this.currentOrder.isGiftClaimed,
        printedAt: this.currentOrder.giftInfo.printedAtshortDatetimeStr
      };
      switch (this.currentOrder.giftInfo.giftDeliveryMethod) {
        case 'email':
          hash.isEGift = true;
          break;
        default:
          hash.isPrintedGift = true;
      }
      return hash;
    }
  };

  SupportCurrentOrderModel.prototype.getDeliveryMessage = function() {
    var days, deliveryMessage, order;
    order = this.currentOrder;
    days = order != null ? order.remainingDeliveryDays : void 0;
    if (days != null) {
      deliveryMessage = I18n.translate('js.modules.support.order_delivery_window_message');
      if (days === 0) {
        return deliveryMessage + I18n.translate('js.modules.support.today');
      } else if (days > 0) {
        return deliveryMessage + I18n.translate('js.modules.support.order_days_message', {
          deliveryDays: days
        });
      }
    }
    return null;
  };

  return SupportCurrentOrderModel;

})();

module.exports = SupportCurrentOrderModel;

//# sourceMappingURL=data:application/json;base64,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
